import React from 'react';
import { CloseIcon } from '../../icons';
import { Button, ButtonProps } from './Button';

interface CloseButtonProps extends ButtonProps {
  iconSize?: number;
}

export const CloseButton = ({ iconSize = 20, ...props }: CloseButtonProps) => {
  return (
    <Button
      aria-label="close"
      color="default"
      variant="icon"
      increaseSpecificity
      sx={{
        width: iconSize * 2,
        height: iconSize * 2,
      }}
      {...props}
    >
      <CloseIcon
        sx={{
          fontSize: iconSize,
        }}
      />
    </Button>
  );
};
